import { Reveal } from "./Reveal";
import { copy } from "@/content";

export const Representation = ({ lang = "en" }) => {
  const t = copy[lang].representation;
  return (
    <section
      id="representation"
      className="relative py-28 sm:py-40"
      data-testid="representation-section"
    >
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="dealer-eyebrow">REPRESENTATION</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-serif text-3xl leading-[1.15] tracking-tight text-dealer-ivory sm:text-4xl lg:text-5xl">
                MORE THAN
                <br />
                REPRESENTATION.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-10 font-sans text-[11px] font-medium tracking-[0.3em] text-dealer-burgundybright">
                PEOPLE&nbsp;&nbsp;|&nbsp;&nbsp;IDEAS&nbsp;&nbsp;|&nbsp;&nbsp;OPPORTUNITIES
              </p>
            </Reveal>
          </div>

          <div className="flex flex-col justify-end lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.15}>
              <p className="text-sm font-light leading-relaxed text-dealer-silver sm:text-base">
                {t.p1}
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <p className="mt-8 text-sm font-light leading-relaxed text-dealer-silver sm:text-base">
                {t.p2}
              </p>
            </Reveal>
            <Reveal delay={0.35}>
              <div className="dealer-rule mt-12" />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
